import * as React from "react";
import { QualityControlGroup, QualityControlSection, QualityControlType } from "./qc-stat";
import { Genome } from "../../api";

// Only used in ATCC
class QualityControl extends React.PureComponent<{
  genome: Genome;
  collectionName: string | null;
  notes: string | null;
}> {
  usesBuscoQC() {
    return !!this.props.collectionName && this.props.collectionName === "mycology";
  }

  usesCheckMQC() {
    return !!this.props.collectionName && this.props.collectionName === "bacteriology";
  }

  render() {
    return (
      <div className="quality-control">
        <QualityControlGroup
          header="Sequencing Quality Control"
          description="Quality control statistics on Illumina sequencing data."
          type={QualityControlType.Illumina}
          genome={this.props.genome}
          collectionName={this.props.collectionName}
        />
        {this.usesCheckMQC() && (
          <QualityControlGroup
            header="Assembly Quality Control"
            description={`Metrics assessing the assembly quality`}
            type={QualityControlType.Assembly}
            genome={this.props.genome}
            collectionName={this.props.collectionName}
          />
        )}
        {this.usesBuscoQC() && (
          <QualityControlGroup
            header="BUSCO Quality Control"
            description="Metrics assessing the assembly quality (from BUSCO)."
            type={QualityControlType.Busco}
            genome={this.props.genome}
            collectionName={this.props.collectionName}
          />
        )}
        {this.props.notes && (
          <QualityControlSection header="Notes">
            <p>{this.props.notes}</p>
          </QualityControlSection>
        )}
      </div>
    );
  }
}

export default QualityControl;
